/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Navigation, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { SET_YOUR_PASSWORD_ROUTE_NAME } from '../../account-activation/models';
import { ResetAccountActivation } from '../../account-activation/store/actions';
import { IUserState } from '../../account-activation/store/state';

@Injectable({
  providedIn: 'root'
})
export class NavigationGuard {
  constructor(private readonly store: Store<IUserState>, private readonly router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const currentNavigation: Navigation | null = this.router.getCurrentNavigation();
    if (!!currentNavigation && currentNavigation.trigger === 'popstate') {
      this.store.dispatch(ResetAccountActivation());
      this.router.navigate([`/${SET_YOUR_PASSWORD_ROUTE_NAME}`]);
      return of(false);
    }

    return of(true);
  }
}
